module.exports = __webpack_public_path__ + "img/setting-icon.a2facd12.png";